/*eslint-disable */
import React, { useEffect, useState } from "react";
import { withFormik, Form as Formiker, Field as Fieldmik, FieldArray } from "formik";
import * as yup from "yup";
import moment from "moment";
import { useHistory } from "react-router-dom";
import {
  Form as FormUi,
  Container,
  TextArea,
  Button,
  Input,
  Segment,
  Dropdown,
  Divider,
  Icon,
  Search,
} from "semantic-ui-react";
import "react-datepicker/dist/react-datepicker.css";
import { DateData } from "../dynamicComponent/datepick";
import { MyNormalInput, MyTextArea, MyTempInput, MyNumInput, MyInput } from "../dynamicComponent/myInputs";
import ContainerSize from "../dynamicComponent/containerSize";
import LoadType from "../dynamicComponent/loadType";
import ShippingLine from "../dynamicComponent/shippingLine";
import CHAInput from "../dynamicComponent/chaInput";
import CategoryList from "../dynamicComponent/categoryList";
import ShowAddress from "../dynamicComponent/showAddress";
import ShowRouteInfo from "../dynamicComponent/showRouteInfo";
import BillingPartyWithCreate from "../dynamicComponent/billingPartyWithCreate";
import {
  createShipmentDispatcher,
  deleteAllOrderDispatcher,
} from "../../redux/actions/shipmentAction";
import { connect } from "react-redux";
import SearchDropdown from "./searchDropdown";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import ReadAxios from "../axiosComponent/read";
import CreatAxios from "../axiosComponent/create";
import UpdateAxios from "../axiosComponent/update";
import { translate } from "react-i18next";
import ConsigneeWithCreate from "../dynamicComponent/consigneeWithCreate";
import ConsignorWithCreate from "../dynamicComponent/consignorWithCreate";
import ModalCreateConsignee from "../createShipmentComponent/modalCreateConsignee";
import ModalCreateConsignor from "../createShipmentComponent/modalCreateConsigner";
import ModalCreateRoute from "../createShipmentComponent/modalCreateRoute";

import ModalCreateBillingParty from "../createShipmentComponent/modalCreateBillingParty";
import BranchDropdown from "../dropdowns/branchDropdown";
import YardDropdown from "../dropdowns/yardDropdown";
import BillingPartyBranch from "../dropdowns/billingPartyBranch";
import { min, isEmpty, values } from "lodash";
import MandatoryMark from "../common/mandatorymark";
import allAxiosCommonRequest from "../axiosComponent/allAxiosCommonRequest";
import allAxiosCommonTA from "../axiosComponent/allAxiosCommonTA";
import cogoToast from "cogo-toast";
import { faSleigh } from "@fortawesome/free-solid-svg-icons";
import MyUser from "../apiInputs/myUser";
import { DateBooking } from "../dynamicComponent/datepickBooking";
import { ddMMyyy_HHmm, HHmm, isReemaClient, requireBillingPartyInBookings, requireConsignrConsigneeMastersInBookings, YYYYMMDD_HHMM, FEATURES } from "../../utils/constant";
import { BOOKING_BRANCH_REQUIRED, BOOKING_CREATION_SUCCESS, BOOKING_UPDATE_SUCCESS, ERROR_CREATING_BOOKING, INVALID_DELIVERY_DATE, REQUIRED } from "../../utils/validationConstant";
import { TOAST_MESSAGES } from "../../utils/toastMsgConstant";

const insertBookingRequestDomesticEdit = ({
  values,
  vehicleTypeMaster,
  setFieldValue,
  touched,
  errors,
  handleSubmit,
  shipment,
  bookingRequestObj,
  routeCodes,
  routeNames,
  mode,
  isSubmitting,
  deleteAllOrderDispatcher,
  t,
  ...props
}) => {
  const [deleteModal, setdeleteModal] = useState(false);
  // const [movementType, setmovementType] = useState("primary");
  const [disable, setmovementTypedisable] = useState(false);
  const [products, setproducts] = useState([]);
  const [vehicles, setvehicletype] = useState([]);
  const [shipmentdata, setShipment] = useState({});
  const [deliveryAddCount, setDeliveryAddCount] = useState({ deliveryIndex: 1 });
  const [service, setService] = useState([]);
  const [hasPTLDelivery, setHasPTLDelivery] = useState(false)

  useEffect(() => {
    setPreselectedValue();
    getServiceType();
    checkForPTLDeliveries()
  }, [bookingRequestObj, hasPTLDelivery]);

  const setPreselectedValue = () => {
    if (mode == "edit" || mode == "view") {
      if (bookingRequestObj.route)
        setRouteAddressState(bookingRequestObj.route);
    }
  };

  const checkForPTLDeliveries = () => {
    let PTLDeliveries = values?.deliveries?.filter((delivery) => delivery.service_type_id == 2)
    if (PTLDeliveries.length > 0) {
      setHasPTLDelivery(true)
    } else {
      setHasPTLDelivery(false)
    }
  }

  const [routeAddressState, setRouteAddressState] = useState("");
  const [masterState, setMasterState] = useState("");
  const getMasterBranchSelected = (branchCode, branchData) => {
    const addedMasterBranchObject = branchData.find(
      (data) => data.branchId === branchCode
    );
    //setMasterState(addedMasterBranchObject.stateId);
  };

  const [consignorAddressState, setConsignorAddressState] = useState("");
  const [consigneeAddressState, setConsigneeAddressState] = useState("");
  const [billingBranchState, setBillingBranchState] = useState("");
  const [billingPartyBranchList, setBillingPartyBranchList] = useState("");
  const setBillingBranch = (billingBranch) => {
    setBillingBranchState(billingBranch);
  };

  const [billingPartyBranch, setBillingPartyBranch] = useState("");
  const setBillingPartyBranchSelected = (
    billingBranchCode,
    billingBranchData
  ) => {
    const addedBillingBranchObject = billingBranchData
      .find();
  };

  const [yardState, setYardState] = useState("");
  const getYardSelected = () => { };

  const history = useHistory();
  const routeBackToBookingAggrid = () => {
    history.push("/booking-request");
  };

  const onChangeDeliveries = (/* e, field,*/event, values, name, setValues) => {
    event.preventDefault();
    event.stopPropagation();

    // update dynamic form
    const deliveries = [...values.deliveries];
    const previousNumber = values.numberOfDeliveries;

    values.numberOfDeliveries += 1;

    const numberOfDeliveries = values.numberOfDeliveries;

    if (previousNumber < numberOfDeliveries) {
      for (let i = previousNumber; i < numberOfDeliveries; i++) {
        let deliveryAddList = getDeliveryArray(values);
        deliveries.push(deliveryAddList);
      }
    } else {
      for (let i = previousNumber; i >= numberOfDeliveries; i--) {
        deliveries.splice(i, 1);
      }
    }

    setValues(name, deliveries);
  }

  const getServiceType = () => {
    ReadAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/masters/service/type`,
    })
      .then((res) => {
        // this.props.create(temShipment);
        let service = res.data.data;
        setService(
          service.map((item, index) => {
            return {
              key: index,
              value: item.service_type_id,
              text: item.service_type_name,
              raw: { ...item },
            };
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };


  const serviceIDMapping = (item) => {
    // console.log(item, "placeholder value")

    if (item != null || undefined) {
      let serviceType = (i) => {
        if (i == 1) {
          return "FTL"
        } else if (i == 2) {
          return "PTL"
        }

      }
      if (item) {
        return serviceType(item)
      } else {
        return " - "
      }
    }
  }

  const getDeliveryArray = (values) => {
    return {
      requested_pickup_date: values?.deliveries?.[0]?.requested_pickup_date ?
        moment(values.deliveries[0].requested_pickup_date, YYYYMMDD_HHMM)
        : "",

      requested_delivery_date: values?.deliveries?.[0]?.requested_delivery_date ?
        moment(values.deliveries[0].requested_delivery_date, YYYYMMDD_HHMM)
        : "",

      billing_party_id: null,

      billing_party_placeholder: "",

      billing_party_branch_id: null,

      billing_party_branch_placeholder: "",

      consignor_code: "",

      consignor_placeholder: "",

      consignee_code: "",

      pickup_area: "",

      drop_area: "",

      // consignee_placeholder:values?.deliveries?.[0]?.consignee_name ?
      // (values.deliveries[0].consignor_name)
      consignee_placeholder: "",

      consignorRaw: "",

      consigneeRaw: "",

      booking_products: [
        {
          product_category_id: "",

          product_category_name: "",
        }
      ]
    }
  }

  const onChangeDeliveriesRemove = (/* e, field,*/ values, name, setValues, index) => {
    // update dynamic form
    const deliveries = [...values.deliveries];
    deliveries.splice(index, 1);

    setValues(name, deliveries);
  }

  return (
    <div>
      <Formiker>
        {/* <AddTitleBar Title="Create Rate Engine" LinkName="/rate-engine" /> */}
        <>
          <>
            <div className="">
              <Divider />
              <>
                <FieldArray name="ShipmentDetails">

                  <div key="ShipmentDetails" className="list-group list-group-flush">
                    <div className="list-group-item padding-0-imp mt-4">
                      <div>
                        <h5 className="card-title">{t("titles.shipmentDetails")}</h5>
                      </div>
                      <>
                        <div className="form-row display-flex-center-justify-spacebtwn">
                          <div className="form-group col-4">
                            <div>
                              <label className="required-form-element">
                                {t("shipment_form.route.title") || "Route"}
                              </label>
                            </div>
                            <div className="display-flex-center">
                              <div className="master-with-search">

                                <SearchDropdown
                                  disabled={mode == "view" ? true : false}
                                  setField={(name, value) => {
                                    setRouteAddressState(value.raw ? value.raw : "");
                                    // setFieldValue("vehicle_number", value.raw ? value.raw.vehicleNumber : value)
                                    setFieldValue(
                                      "route",
                                      value.raw ? value.raw.routeCode : ""
                                    );
                                    setFieldValue(
                                      "deliveries[0].requested_delivery_date",
                                      //values.requested_pickup_date
                                      value.raw ? moment(values.deliveries[0].requested_pickup_date).add(value.raw.budgetedRouteTat, 'hours').format(YYYYMMDD_HHMM) : ""
                                    );
                                  }}
                                  placeholder={values.route_placeholder}
                                  masterRoute="routeMaster"
                                  masterRouteKey="routeMasterId"
                                  masterRouteName="routeName"
                                  className="ui placeholder-black"
                                  fieldName="route"
                                  error={
                                    touched.route &&
                                      errors.route
                                      ? true
                                      : false
                                  }
                                  blurMessage={t("shipment_form.route.blur_msg")}
                                />
                                {touched.route && errors.route ? (
                                  <div className="w3-small w3-text-red">
                                    {t("shipment_form.route.error_msg.invalid")}
                                  </div>
                                ) : null}

                              </div>
                              <div>
                                <ModalCreateRoute />
                              </div>
                            </div>
                          </div>
                          <div className="form-group col-3"></div>
                          <div className="form-group col-4">
                            <div>
                              <label className="required-form-element">
                                {t("shipment_form.vehicles_count.title") ||
                                  "Vehicle Count"}
                              </label>
                            </div>
                            <div className="adjust-width-cell">
                              <Fieldmik
                                className="placeholder-black"
                                disabled={(mode == "view" || hasPTLDelivery) ? true : false}
                                component={MyNumInput}
                                value={values.number_of_vehicles}
                                name="number_of_vehicles"
                                type="number"
                                min={0}
                              />
                            </div>
                          </div>
                          <div className="form-group col-1"></div>
                        </div>
                        <div className="form-row display-flex-center-justify-spacebtwn">
                          <div className="form-group col-4">
                            <Fieldmik
                              disabled={mode == "view" ? true : false}
                              component={ShowRouteInfo}
                              id={values.route}
                              values={values}
                              mode={mode}
                              bookingDeliveryDateName={`deliveries[0].requested_delivery_date`}
                              requested_pickup_date_booking={values.deliveries[0].requested_pickup_date}
                              requested_delivery_date_booking={values.deliveries[0].requested_delivery_date}
                              routeAddressState={routeAddressState}
                              name="show_route_info"
                            />
                          </div>
                          <div className="form-group col-3"></div>
                          <div className="form-group col-4">
                          </div>
                          <div className="form-group col-1"></div>
                        </div>

                        <div className="form-row display-flex-center-justify-spacebtwn">
                          <div className="form-group col-4">
                            <div>
                              <label className="required-form-element">{"Load type"}</label>
                            </div>
                            <div>
                              <Fieldmik
                                disabled={mode == "view" ? true : false}
                                placeholder={values.load_type_placeholder}
                                component={LoadType}
                                name="load_type"
                                default={bookingRequestObj.load_type || "Dry"}
                              />
                            </div>
                          </div>
                          <div className="form-group col-3"></div>
                          <div className="form-group col-4">
                            <div>
                              <label>
                                {t("shipment_form.remarks.title") || "Remarks"}
                              </label>
                            </div>
                            <div>
                              <Fieldmik
                                disabled={mode == "view" ? true : false}
                                placeholder={values.remarks}
                                component={MyTextArea}
                                name="remarks"
                              />
                            </div>
                          </div>
                          <div className="form-group col-1"></div>
                        </div>
                      </>
                    </div>
                  </div>
                </FieldArray>
                <FieldArray name="OrderDetails">

                  <div key="OrderDetails" className="list-group list-group-flush">
                    <div className="list-group-item padding-0-imp mt-4">
                      <div>
                        <h5 className="card-title">{t("titles.orderDetails")}</h5>
                      </div>
                      <>
                        <div className="form-row display-flex-center-justify-spacebtwn">
                          <div className="form-group col-4">
                            <div>
                              <label>
                                {t("shipment_form.weight.title") || "Weight (in kgs)"}
                              </label>
                            </div>
                            <div className="adjust-width-cell">
                              <Fieldmik
                                className="placeholder-black"
                                component={MyNumInput}
                                name="weight"
                                disabled={mode == "view" ? true : false}
                                placeholder={values.weight} />
                            </div>
                          </div>
                          <div className="form-group col-3"></div>
                          <div className="form-group col-4">
                            <div>
                              <label>
                                {t("shipment_form.vehicle_type.title") || "Vehicle Type"}
                              </label>
                            </div>
                            <div className="adjust-width-cell">
                              <SearchDropdown
                                disabled={mode == "view" ? true : false}
                                setField={(name, value) => {
                                  // setFieldValue("vehicle_number", value.raw ? value.raw.vehicleNumber : value)
                                  setFieldValue(
                                    "vehicle_type",
                                    value.raw ? value.raw.vehicleTypeId : ""
                                  );
                                }}
                                placeholder={values.vehicle_type_placeholder}
                                className="ui fluid input placeholder-black"
                                masterRoute="vehicleTypeMaster"
                                masterRouteKey="vehicleTypeId"
                                masterRouteName="vehicleType"
                                fieldName="vehicle_type"
                              />
                            </div>
                          </div>
                          <div className="form-group col-1"></div>
                        </div>

                        {values.load_type != 4 ? (
                          <div className="form-row display-flex-center-justify-spacebtwn">

                            <div className="form-group col-4">
                              <div>
                                <label>
                                  {t("shipment_form.temp_min.title") ||
                                    "Temperature Minimum"}
                                </label>
                              </div>
                              <div>
                                <Fieldmik
                                  disabled={mode == "view" ? true : false}
                                  component={MyTempInput}
                                  className="placeholder-black"
                                  name="temp_min"
                                  placeholder={values.temp_min}
                                  icon="thermometer quarter"
                                  iconPosition="left"
                                  style={{ paddingTop: "5.5px" }}
                                />
                              </div>
                            </div>
                            <div className="form-group col-3"></div>
                            <div className="form-group col-4">
                              <div>
                                <label>
                                  {t("shipment_form.temp_max.title") ||
                                    "Temperature Maximum"}
                                </label>
                              </div>
                              <div>
                                <Fieldmik
                                  disabled={mode == "view" ? true : false}
                                  component={MyTempInput}
                                  className="placeholder-black"
                                  name="temp_max"
                                  placeholder={values.temp_max}
                                  icon="thermometer quarter"
                                  iconPosition="left"
                                  style={{ paddingTop: "5.5px" }}
                                />
                                {touched.temp_max && errors.temp_max && <div>{t("shipment_form.temp_max.error_msg.greater_than_min")}</div>}
                              </div>
                            </div>
                            <div className="form-group col-1"></div>
                          </div>
                        ) : (
                          ""
                        )}
                      </>
                    </div>
                  </div>
                </FieldArray>
                <div className="text-center border-top-0 display-flex-center-justify-spacebtwn mt-4">
                  <div>
                    <h4>{t("titles.deliveryDetails")}</h4>
                  </div>
                  {mode != "view" ?

                    <button className="ui mini basic icon primary button" onClick={(e) => { onChangeDeliveries(e, values, 'deliveries', setFieldValue) }} hidden={hasPTLDelivery}>
                      <i aria-hidden="true" class="plus icon"></i>
                      {t("action_buttons.new_delivery")}
                    </button>
                    : null}
                </div>
                <br />
                <FieldArray name="deliveries">
                  {() => (values.deliveries.map((deliveryObj, i) => {
                    const deliveryObjErrors = errors.deliveries?.length && errors.deliveries[i] || {};
                    const deliveryObjTouched = touched.deliveries?.length && touched.deliveries[i] || {};
                    if (values.deliveries[i].service_type_id == 2) {
                      setHasPTLDelivery(true)
                    }
                    return (
                      <div key={i} className="list-group list-group-flush">
                        <div className="list-group-item padding-0-imp">
                          <div className="display-flex-center-justify-spacebtwn mt-2 mb-2">
                            <h5 className="card-title">{t('titles.deliveryDetails')} {i + 1}</h5>
                            {(i >= 1 && mode != "view") ?
                              <button className="ui red mini basic icon button" onClick={() => { onChangeDeliveriesRemove(values, 'deliveries', setFieldValue, i) }} >
                                <i aria-hidden="true" class="trash icon"></i>
                                {t("action_buttons.delivery")}
                              </button>
                              : null
                            }
                          </div>
                          <>
                            <div className="form-row display-flex-center-justify-spacebtwn">
                              <div className="form-group col-4">
                                <div>
                                  <label className="required-form-element">
                                    {t("shipment_form.pick_up_date.title") ||
                                      "Requested Pickup Date"}
                                  </label>
                                </div>
                                <div>
                                  <DateBooking
                                    disabled={mode == "view" ? true : false}
                                    name={`deliveries[${i}].requested_pickup_date`}
                                    tname={`deliveries[${i}].requested_pickup_date`}
                                    autoComplete="off"
                                    showTimeSelect
                                    setDeliveryDate={`deliveries[${i}].requested_delivery_date`}
                                    values={values}
                                    timeFormat={HHmm}
                                    popperClassName="dateTime"
                                    dateFormat={ddMMyyy_HHmm}
                                    timeIntervals={5}
                                    customInput={
                                      <Input
                                        icon="time"
                                        className="poupDate"
                                        iconPosition="left"
                                      />
                                    }
                                  />
                                </div>
                              </div>
                              <div className="form-group col-3"></div>
                              <div className="form-group col-4">
                                <div>
                                  <label className="required-form-element">
                                    {t("shipment_form.delivery_up_date.title") ||
                                      "Expected Delivery Date"}
                                  </label>
                                </div>
                                <div>
                                  <DateData
                                    disabled={mode == "view" ? true : false}
                                    name={`deliveries[${i}].requested_delivery_date`}
                                    tname={`deliveries[${i}].requested_delivery_date`}
                                    autoComplete="off"
                                    showTimeSelect
                                    timeFormat={HHmm}
                                    popperClassName="dateTime"
                                    dateFormat={ddMMyyy_HHmm}
                                    timeIntervals={5}
                                    customInput={
                                      <Input
                                        icon="time"
                                        className="poupDate"
                                        iconPosition="left"
                                      />
                                    }
                                  />
                                  {errors?.deliveries?.[i]?.requested_delivery_date ? (
                                    <div className="w3-small w3-text-red">
                                      {t("shipment_form.delivery_up_date.error_msg.invalid")}
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                              <div className="form-group col-1"></div>
                            </div>
                            <div className="form-row display-flex-center-justify-spacebtwn">
                              <div className="form-group col-4">
                                {!requireBillingPartyInBookings ?
                                  <label className="">
                                    {t("shipment_form.billing_party.title") ||
                                      "Billing Party"}
                                  </label>
                                  :
                                  <label className="required-form-element">
                                    {t("shipment_form.billing_party.title") ||
                                      "Billing Party"}
                                  </label>
                                }
                                <Fieldmik
                                  disabled={mode == "view" ? true : false}
                                  placeholder={
                                    values.deliveries[i].billing_party_placeholder
                                  }
                                  component={BillingPartyWithCreate}
                                  placeholderName={`deliveries[${i}].billing_party_placeholder`}
                                  name={`deliveries[${i}].billing_party_id`}
                                  dataId="billingBranchState"
                                  setBillingBranch={setBillingBranch}
                                  error={
                                    deliveryObjErrors.billing_party_id && deliveryObjTouched.billing_party_id ? true : false
                                  }
                                />
                                {deliveryObjErrors?.billing_party_id && deliveryObjTouched?.billing_party_id ? (
                                  <div className="w3-small w3-text-red">
                                    {t("shipment_form.billing_party.error_msg.required")}
                                  </div>
                                ) : null}
                              </div>
                              <div className="form-group col-3"></div>
                              <div className="form-group col-4">
                                <label>{"Billing Party Branch"}</label>
                                <Fieldmik
                                  disabled={mode == "view" ? true : false}
                                  style={{ width: "100%" }}
                                  component={BillingPartyBranch}
                                  name={`deliveries[${i}].billing_party_branch_id`}
                                  placeholderName={`deliveries[${i}].billing_party_branch_placeholder`}
                                  placeholder={
                                    values.deliveries[i].billing_party_branch_placeholder
                                  }
                                  id={values.deliveries[i].billing_party_id}
                                  billingBranchState={billingBranchState}
                                  billingPartyBranchList={billingPartyBranchList}
                                  setBillingPartyBranchSelected={setBillingPartyBranchSelected}
                                />
                              </div>
                              <div className="form-group col-1"></div>
                            </div>

                            <div className="form-row display-flex-center-justify-spacebtwn">
                              <div className="form-group col-4">
                                {!requireConsignrConsigneeMastersInBookings ?
                                  <label className="">
                                    {t("shipment_form.consignor.title") || "Consignor Name"}
                                  </label>
                                  :
                                  <label className="required-form-element">
                                    {t("shipment_form.consignor.title") || "Consignor Name"}
                                  </label>
                                }
                                <Fieldmik
                                  disabled={mode == "view" ? true : false}
                                  placeholder={
                                    values.deliveries[i].consignor_placeholder
                                  }
                                  component={ConsignorWithCreate}
                                  name={`deliveries[${i}].consignor_code`}
                                  consignorRaw={`deliveries[${i}].consignorRaw`}
                                  consignor_placeholder={`deliveries[${i}].consignor_placeholder`}
                                  setRaw="consignorRaw"
                                  //fillAddressState={setConsignorAddressState}
                                  error={
                                    deliveryObjErrors.consignor_code && deliveryObjTouched.consignor_code ? true : false
                                  }
                                />
                                {deliveryObjErrors?.consignor_code && deliveryObjTouched?.consignor_code ? (
                                  <div className="w3-small w3-text-red">
                                    {t("shipment_form.consignor.error_msg.required")}
                                  </div>
                                ) : null}

                              </div>
                              <div className="form-group col-3"></div>
                              <div className="form-group col-4">
                                {!requireConsignrConsigneeMastersInBookings ?
                                  <label className="">
                                    {t("shipment_form.consignee.title") || "Consignee Name"}
                                  </label>
                                  :
                                  <label className="required-form-element">
                                    {t("shipment_form.consignee.title") || "Consignee Name"}
                                  </label>
                                }
                                <Fieldmik
                                  disabled={mode == "view" ? true : false}
                                  placeholder={
                                    values.deliveries[i].consignee_placeholder
                                  }
                                  component={ConsigneeWithCreate}
                                  name={`deliveries[${i}].consignee_code`}
                                  consigneeRaw={`deliveries[${i}].consigneeRaw`}
                                  consignee_placeholder={`deliveries[${i}].consignee_placeholder`}
                                  setRaw="consigneeRaw"
                                  error={
                                    deliveryObjErrors.consignee_code && deliveryObjTouched.consignee_code ? true : false
                                  }
                                />
                                {deliveryObjErrors.consignee_code && deliveryObjTouched.consignee_code ? (
                                  <div className="w3-small w3-text-red">
                                    {t("shipment_form.consignee.error_msg.required")}
                                  </div>
                                ) : null}

                              </div>
                              <div className="form-group col-1"></div>
                            </div>

                            <div className="form-row display-flex-center-justify-spacebtwn">
                              <div className="form-group col-4">
                                <Fieldmik
                                  disabled={mode == "view" ? true : false}
                                  component={ShowAddress}
                                  id={`values.deliveries[${i}].consignor_code`}
                                  setAddressState={values.deliveries[i].consignorRaw}//{consignorAddressState}
                                  name={`deliveries[${i}].consignorRaw`}
                                  data={`values.deliveries[${i}].consignorRaw`}
                                />
                                <br />
                                Pickup Area
                                <Fieldmik
                                  disabled={mode == "view" ? true : false}
                                  placeholder="Pickup Area"
                                  component={MyTextArea}
                                  name={`deliveries[${i}].pickup_area`}
                                />
                              </div>
                              <div className="form-group col-3"></div>
                              <div className="form-group col-4">
                                <Fieldmik
                                  disabled={mode == "view" ? true : false}
                                  component={ShowAddress}
                                  id={`values.deliveries[${i}].consignee_code`}
                                  name={`deliveries[${i}].consigneeRaw`}
                                  setAddressState={values.deliveries[i].consigneeRaw}//{consigneeAddressState}
                                  data={`values.deliveries[${i}].consigneeRaw`}
                                />
                                <br />
                                Drop Area
                                <Fieldmik
                                  disabled={mode == "view" ? true : false}
                                  placeholder="Drop Area"
                                  component={MyTextArea}
                                  name={`deliveries[${i}].drop_area`}

                                />
                              </div>
                              <div className="form-group col-1"></div>
                            </div>
                          </>
                          <div className="form-row display-flex-center-justify-spacebtwn">
                            <div className="form-group col-4">
                              <FormUi.Field
                                width={6}
                                error={
                                  touched.service_type_id && errors.service_type_id
                                    ? true
                                    : false
                                }
                              >
                                <label className="labelName mt-2">
                                  {t("service_type.title") || "Service Types"}{" "}
                                </label>
                                <Dropdown
                                  clearable
                                  style={{ width: "100%", fontWeight: "normal" }}
                                  search
                                  selection
                                  name={`values.deliveries[${i}].service_type_id`}
                                  placeholder={
                                    serviceIDMapping(values.deliveries[i].service_type_id)
                                  }
                                  onChange={(name, data) => {
                                    setFieldValue(`deliveries[${i}].service_type_id`, data.value)
                                    if (data.value == 2) {
                                      setFieldValue('number_of_vehicles', 1)
                                      setHasPTLDelivery(true)
                                    } else {
                                      setHasPTLDelivery(false)
                                    }
                                  }
                                  }
                                  options={service}
                                />
                                {touched.service_type_id &&
                                  errors.service_type_id ? (
                                  <div className="w3-small w3-text-red">
                                    {t(
                                      `service_type.error_msg.${errors.service_type}`
                                    ) || errors.service_type}
                                  </div>
                                ) : null}
                              </FormUi.Field>
                            </div>

                            <div className="form-group col-3"></div>
                              <div className="form-group col-4">
                                  <label className="labelName mt-2">
                                    {FEATURES.brokerInsteadOfSalesPerson ? (t("broker.title") || "Broker") :  (t("sales_person.title") || "Sales Person")}{" "}
                                  </label>
                                  
                                  <Fieldmik
                                  disabled={mode == "view" ? true : false}
                                  placeholder= {FEATURES.brokerInsteadOfSalesPerson ? (t("broker.placeholder") || "Broker") : (t("sales_person.placeholder") || "Select Sales Person")}
                                  component={MyUser}
                                  name={`deliveries[${i}].sales_person_id`}
                                  roleValidation={true}
                                  roleName={FEATURES.brokerInsteadOfSalesPerson ? "broker" : "sales"}
                                  userNumber={`deliveries[${i}].sales_person_number`}
                                  userEmail={`deliveries[${i}].sales_person_email`}
                                  value={values.deliveries[i].sales_person_id}
                                />
                                  {touched.sales_person_id &&
                                    errors.sales_person_id ? (
                                    <div className="w3-small w3-text-red">
                                      {errors.service_type}
                                    </div>
                                  ) : null}
                                  {values.deliveries[i].sales_person_id && 
                                  <div className="display-flex-center flex-wrap mt-1">
                                  <div>
                                    <span className="address-label">{"Contact Number"}</span>
                                    <span className="address-inputfields"> : {values.deliveries[i].sales_person_number}
                                    </span>
                                  </div>
                                  <div className="address-divider">|</div>
                                  <div>
                                    <span className="address-label">{"Email Id"}</span>
                                    <span className="address-inputfields"> : {values.deliveries[i].sales_person_email}
                                    </span>
                                  </div>
                                </div>
                                  }
                              </div>
                              <div className="form-group col-1"></div>

                          </div>
                          <div className="form-group col-3"></div>

                          <>
                            <Divider />
                            <h5 className="card-title">{t("titles.productDetails")} {i + 1}</h5>

                            <>
                              <div className="form-row">
                                <div className="form-group col-4">
                                  <label>{"Category"}</label>
                                  <Fieldmik
                                    disabled={mode == "view" ? true : false}
                                    placeholder={
                                      values?.deliveries?.[i]?.booking_products?.[0]?.product_category_name
                                    }
                                    component={CategoryList}
                                    placeholderName={`deliveries[${i}].booking_products[0].product_category_name`}
                                    name={`deliveries[${i}].booking_products[0].product_category_id`}
                                  />
                                </div>
                              </div>
                            </>
                          </>
                        </div>
                      </div>
                    );
                  }))}
                </FieldArray>
              </>
            </div>
          </>
          <center>
            {mode != "view" ?
              <Button
                type="submit"
                className="m-2"
                primary
                size="mini"
                onClick={handleSubmit}
                disabled={values.disable_submit}
              >
                {t("action_buttons.submit")}
              </Button>
              : null}
            <Button
              type="submit"
              className="m-2"
              secondary
              size="mini"
              onClick={() => { routeBackToBookingAggrid() }}
            >
              {t("action_buttons.cancel")}
            </Button>
          </center>
        </>
      </Formiker>

    </div>
  );
};

const FormikShipment = withFormik({
  enableReinitialize: true,
  validationSchema: yup.object().shape(
    {
      route: yup.string().required(REQUIRED),
      temp_min: yup.number().optional().nullable()
        .when("temp_max", (temp_max) =>
          temp_max ? yup.number().optional().nullable().max(temp_max, "max") : yup.number().optional().nullable()
        ),
      temp_max: yup.number().optional().nullable()
        .when("temp_min", (temp_min) =>
          temp_min ? yup.number().optional().nullable().min(temp_min, "min") : yup.number().optional().nullable()
        ),
      deliveries: yup.array().of(
        yup.object().shape({
          billing_party_id: yup.number()
            .when(`${requireBillingPartyInBookings}`, {
              is: (value) => { if (requireBillingPartyInBookings) return true; else return false; },
              then: yup.number().required(REQUIRED),
              otherwise: yup.number().optional().nullable()
            }),
          consignee_code: yup.string()
            .when(`${requireConsignrConsigneeMastersInBookings}`, {
              is: (value) => { if (requireConsignrConsigneeMastersInBookings) return true; else return false; },
              then: yup.string().required(REQUIRED),
              otherwise: yup.string()
            }),
          pickup_area: yup.string(),
          drop_area: yup.string(),
          consignor_code: yup.string()
            .when(`${requireConsignrConsigneeMastersInBookings}`, {
              is: (value) => { if (requireConsignrConsigneeMastersInBookings) return true; else return false; },
              then: yup.string().required(REQUIRED),
              otherwise: yup.string()
            }),
          pickup_area: yup.string().optional(),
          drop_area: yup.string().optional(),
          requested_pickup_date: yup.date(),
          requested_delivery_date: yup.date().min(
            yup.ref('requested_pickup_date'),
            INVALID_DELIVERY_DATE
          )
        },
          [["requested_pickup_date", "requested_delivery_date"]]
        )
      )
    },
    [["temp_max", "temp_min"]]
  ),

  mapPropsToValues: (props) => ({
    disable_submit: false,
    deliveries: (props.mode == 'edit' || props.mode == 'view') && props?.bookingRequestObj?.deliveryBooking ?
      [...props.bookingRequestObj.deliveryBooking]
      :
      [
        {
          requested_pickup_date:
            props.bookingRequestObj && props.bookingRequestObj.requested_pickup_date_booking
              ? moment(props.bookingRequestObj.requested_pickup_date_booking, YYYYMMDD_HHMM)
              : moment(new Date(), YYYYMMDD_HHMM),
          requested_delivery_date:
            props.bookingRequestObj && props.bookingRequestObj.requested_delivery_date_booking
              ? moment(props.bookingRequestObj.requested_delivery_date_booking, YYYYMMDD_HHMM)
              : "",
          billing_party_id:
            props.bookingRequestObj && props.bookingRequestObj.billing_party_id
              ? props.bookingRequestObj.billing_party_id
              : null,
          billing_party_placeholder:
            props.bookingRequestObj && props.bookingRequestObj.billing_party_name
              ? props.bookingRequestObj.billing_party_name
              : "",
          billing_party_branch_id:
            props.bookingRequestObj && props.bookingRequestObj.billing_party_branch_id
              ? props.bookingRequestObj.billing_party_branch_id
              : null,
          billing_party_branch_placeholder:
            props.bookingRequestObj &&
              props.bookingRequestObj.billing_party_branch_name
              ? props.bookingRequestObj.billing_party_branch_name
              : "",
          pickup_area:
            props.bookingRequestObj && props.bookingRequestObj.pickup_area
              ? props.bookingRequestObj.pickup_area
              : "",
          drop_area:
            props.bookingRequestObj && props.bookingRequestObj.drop_area
              ? props.bookingRequestObj.drop_area
              : "",
          sales_person_id:
              props.bookingRequestObj && props.bookingRequestObj.sales_person_id
                ? props.bookingRequestObj.sales_person_id
                : "",
          consignor_code:
            props.bookingRequestObj && props.bookingRequestObj.consignor_code
              ? props.bookingRequestObj.consignor_code
              : "",
          consignor_placeholder:
            props.bookingRequestObj && props.bookingRequestObj.consignor
              ? props.bookingRequestObj.consignor.consignor_name
              : "",
          consignee_code:
            props.bookingRequestObj && props.bookingRequestObj.consignee_code
              ? props.bookingRequestObj.consignee_code
              : "",
          consignee_placeholder:
            props.bookingRequestObj && props.bookingRequestObj.consignee
              ? props.bookingRequestObj.consignee.consignee_name
              : "",
          consignorRaw:
            props.bookingRequestObj && props.bookingRequestObj.consignorRaw
              ? props.bookingRequestObj.consignorRaw
              : "",
          consigneeRaw:
            props.bookingRequestObj && props.bookingRequestObj.consigneeRaw
              ? props.bookingRequestObj.consigneeRaw
              : "",
          pickup_area: props.pickup_area
            ? props.pickup_area.pickup_area
            : "",
          drop_area: props.drop_area
            ? props.drop_area.drop_area
            : "",
          service_type_id:
            props.bookingRequestObj && props.bookingRequestObj.service_type_id
              ? props.bookingRequestObj.service_type_id
              : "",
          booking_products: [
            {
              product_category_id:
                props.bookingRequestObj && props.bookingRequestObj.product_category_id
                  ? props.bookingRequestObj.product_category_id
                  : null,
              product_category_name:
                props.bookingRequestObj && props.bookingRequestObj.product_category_name
                  ? props.bookingRequestObj.product_category_name
                  : "",
            }
          ]
        }
      ],
    numberOfDeliveries: props.bookingRequestObj && props.bookingRequestObj.deliveryBooking ? props.bookingRequestObj.deliveryBooking.length : 1,
    route:
      props.bookingRequestObj && props.bookingRequestObj.route
        ? props.bookingRequestObj.route_code
        : "",
    route_placeholder:
      props.bookingRequestObj && props.bookingRequestObj.route
        ? props.bookingRequestObj.route.route_name
        : "",
    number_of_vehicles:
      props.bookingRequestObj && props.bookingRequestObj.no_of_vehicles
        ? props.bookingRequestObj.no_of_vehicles
        : 1,
    show_route_info:
      props.bookingRequestObj && props.bookingRequestObj.route_name
        ? props.bookingRequestObj.route_name
        : "",
    do_number:
      props.bookingRequestObj && props.bookingRequestObj.DO_no
        ? props.bookingRequestObj.DO_no
        : "",
    load_type:
      props.bookingRequestObj && props.bookingRequestObj.load_type?.load_type_id != undefined
        ? props.bookingRequestObj.load_type.load_type_id
        : 4,
    load_type_placeholder:
      props.bookingRequestObj && props.bookingRequestObj.load_type?.load_type_name != undefined
        ? isReemaClient && props.bookingRequestObj.load_type.load_type_name.toLowerCase() == 'frozen' ? "Reefer" : props.bookingRequestObj.load_type.load_type_name
        : "Dry",
    remarks:
      props.bookingRequestObj && props.bookingRequestObj.remarks
        ? props.bookingRequestObj.remarks
        : "",
    weight:
      props.bookingRequestObj && props.bookingRequestObj.weight
        ? props.bookingRequestObj.weight
        : "",
    vehicle_type:
      props.bookingRequestObj && props.bookingRequestObj.vehicle_type_id
        ? props.bookingRequestObj.vehicle_type_id
        : null,
    vehicle_type_placeholder:
      props.bookingRequestObj && props.bookingRequestObj.vehicle_type
        ? props.bookingRequestObj.vehicle_type
        : "",
    temp_min:
      props.bookingRequestObj && props.bookingRequestObj.min_temp
        ? parseInt(props.bookingRequestObj.min_temp)
        : "",
    temp_max:
      props.bookingRequestObj && props.bookingRequestObj.max_temp
        ? parseInt(props.bookingRequestObj.max_temp)
        : "",
    budgeted_kms:
      props.bookingRequestObj && props.bookingRequestObj.route
        ? props.bookingRequestObj.route.budgeted_kms : "",
    service_type_id:
      props.bookingRequestObj && props.bookingRequestObj.service_type_id
        ? props.bookingRequestObj.service_type_id
        : "",
    budgeted_time:
      props.bookingRequestObj && props.bookingRequestObj.route
        ? props.bookingRequestObj.route.budgeted_time
        : "",
  }),
  handleSubmit(values, { setFieldValue, setSubmitting, props }) {
    setFieldValue("disable_submit", true);

    let booking_number = props.booking_number;
    let booking_date = moment(props.requested_pickup_date).format(YYYYMMDD_HHMM);
    let booking_branch_id = parseInt(props.branch);
    this.handleDomesticRequest(
      booking_number,
      booking_date,
      booking_branch_id,
      values,
      setFieldValue,
      props
    );
  },
  handleDomesticRequest(
    booking_number,
    booking_date,
    booking_branch_id,
    values,
    setFieldValue,
    props
  ) {
    var data = {
      ...props?.bookingValues,
      booking_number: booking_number,
      booking_date: moment(props.requested_booking_date).format(YYYYMMDD_HHMM),
      booking_branch_id: booking_branch_id,
      movement_type: props.movement_type,
      route_code: values.route,
      load_type_id: values.load_type,
      remarks: values.remarks,
      no_of_vehicles: parseInt(values.number_of_vehicles),
      weight: parseInt(values.weight),
      vehicle_type_id: values.vehicle_type,
      min_temp: parseInt(values.temp_min),
      max_temp: parseInt(values.temp_max),
      budgeted_time: this.ParseFloat(values.budgeted_time, 2),
      budgeted_kms: this.ParseFloat(values.budgeted_kms, 2),
      booking_deliveries: values.deliveries,
      service_type_id: values.service_type_id
    };
    if(FEATURES.creditCheckRequired && !data.expected_billing_amount){
      setFieldValue("disable_submit", false);
      cogoToast.error(TOAST_MESSAGES.FIELD_REQUIRED("Expected Billing Amount"))
      return;
    }

    for (let index = 0; index < data.booking_deliveries.length; index++) {
      data.booking_deliveries[index].requested_pickup_date = moment(data.booking_deliveries[index].requested_pickup_date).format(YYYYMMDD_HHMM);
      data.booking_deliveries[index].requested_delivery_date = moment(data.booking_deliveries[index].requested_delivery_date).format(YYYYMMDD_HHMM);
    }

    if (props.mode == "edit") {
      data.budgeted_time = this.ParseFloat(values.budgeted_time, 2);
      data.budgeted_kms = this.ParseFloat(values.budgeted_kms, 2);

      for (let index = 0; index < data.booking_deliveries.length; index++) {
        if (data?.booking_deliveries?.[index]?.booking_delivery_id)
          data.booking_deliveries[index].booking_delivery_id = props.bookingRequestObj.booking_deliveries[index].booking_delivery_id;
        else
          data.booking_deliveries[index].booking_delivery_id = null;
        if (values?.deliveries?.[index]?.booking_products) {
          for (let jindex = 0; jindex < values.deliveries[index].booking_products.length; jindex++) {
            if (values?.deliveries?.[index]?.booking_products?.[jindex]?.product_category_id) {
              data.booking_deliveries[index].booking_products[jindex].booking_product_id = values.deliveries[index].booking_products[jindex].product_category_id;
              data.booking_deliveries[index].booking_products[jindex].product_category_name = values.deliveries[index].booking_products[jindex].product_category_name;
            } else {
              data.booking_deliveries[index].booking_products.splice(jindex, 1);
            }
          }

          data.booking_deliveries[index].booking_products = data.booking_deliveries[index].booking_products.filter(function (el) {
            return el != null;
          });
        }
      }

    } else {
      data.budgeted_time = this.ParseFloat(values.budgeted_time, 2);
      data.budgeted_kms = this.ParseFloat(values.budgeted_kms, 2);
      for (let index = 0; index < data.booking_deliveries.length; index++) {
        if (values?.deliveries?.[index]?.booking_products) {
          for (let jindex = 0; jindex < values.deliveries[index].booking_products.length; jindex++) {
            // console.log(values.deliveries[index].booking_products[jindex])
            if (values?.deliveries?.[index]?.booking_products?.[jindex] && values?.deliveries?.[index]?.booking_products?.[jindex]?.product_category_name) {
              data.booking_deliveries[index].booking_products[jindex].product_category_name = values.deliveries[index].booking_products[jindex].product_category_name;
            }
            else {
              data.booking_deliveries[index].booking_products.splice(jindex, 1);
            }
          }

          data.booking_deliveries[index].booking_products = data.booking_deliveries[index].booking_products.filter(function (el) {
            return el != null;
          });

        }
      }
    }


    let requestData = {};
    if (props.mode == "edit") {
      let bookingID = props.bookingRequestObj.booking_id;
      requestData.requestFormat = {
        url: `/bookings/${bookingID}`,
        method: "PATCH",
        Items: data,
      };
    } else {
      requestData.requestFormat = {
        url: "/bookings",
        method: "post",
        Items: data,
      };
    }
    if (booking_branch_id) {
      this.requestToAPI(requestData, props, setFieldValue);
    }
    else {
      setFieldValue("disable_submit", false);
      cogoToast.error(BOOKING_BRANCH_REQUIRED)
    }
  },
  ParseFloat(str, val) {
    str = str.toString();
    if (str.indexOf(".") > 1)
      str = str.slice(0, str.indexOf(".") + val + 1);
    let convertValue = parseFloat(str).toFixed(2) * 1.00;
    return (convertValue);
  },
  requestToAPI(requestData, props, setFieldValue) {
    let request = requestData.requestFormat;

    allAxiosCommonTA({
      url: request.url,
      method: request.method,
      Items: request.Items,
    })
      .then((response) => {
        if (response.message) {
          cogoToast.success(response.message);
        } else {
          cogoToast.success(BOOKING_UPDATE_SUCCESS);
        }

        props.routeBackToListing();
      })
      .catch((err) => {
        setFieldValue("disable_submit", false);
        if (err.data && (err.data.error || err.data.message)) {
          if (err.data.message) {
            cogoToast.success(err.data.message);
            if (err.data.message == BOOKING_CREATION_SUCCESS) {
              props.routeBackToListing();
            }
          } else {
            cogoToast.error(err.data.error);
          }
        }else if(err?.response?.data?.message) cogoToast.error(err?.response?.data?.message);
         else cogoToast.error(ERROR_CREATING_BOOKING);
      });
  },
})(insertBookingRequestDomesticEdit);

const mapStateToProps = ({ shipment }) => {
  return {
    shipment,
  };
};

export default connect(mapStateToProps, {
  createShipmentDispatcher,
  successAlertDispatcher,
  errorAlertDispatcher,
  deleteAllOrderDispatcher,
})(translate("create_booking_request")(FormikShipment));
